import { useEffect } from "react";
import useComponentsStore from "../../store/componentsStateStore";
import Mapper from "../../mappers/Mapper";
import SkeletonLoader from "../skeletonLoader/SkeletonLoader";
import useAppStore from "../../store/AppStore";
import { InitDraft } from "../../api/InitDraft.api";
import { ResType } from "../../interfaces";
import LearnMoreModal from "../learnMoreModal/LearnMoreModal";
import "react-loading-skeleton/dist/skeleton.css";
import "../../Bootstrap.css";
import ContactUs from "../contactUs/ContactUs";
import { useLogging } from "../../membership/logging/hooks/useLogging";
import { logOrderProductsView } from "../../membership/logging/helpers/commonLoggingFunctions";
import { Toast } from "../../interfaces/globalTypes/GlobalTypes.type";
import { styleHelper } from "../../helpers/commonFunctions";
import PostCartInfo from "../postCartInfo/PostCartInfo";
import styles from "./VasServices.module.css";
// import ConfirmationModal from "../confirmationModal/ConfirmationModal";
// import useConfirmationStore from "../../store/confirmationStore";

const VasServices = ({
  token,
  handleEnableBackButton,
  trigger,
  loggingConfig,
  setTrigger,
  setPromoteFlowCloseText,
  setPromoteFlowTitle,
  handleToast,
}: {
  token: string;
  handleEnableBackButton: (value: boolean) => void;
  trigger: boolean;
  loggingConfig?: {
    version?: string;
    loggingEnv?: { url: string; token: string };
    sessionFunnelSource?: string;
    sessionFunnelPointOfEntry?: string;
  };
  setTrigger: (value: boolean) => void;
  setPromoteFlowCloseText: (value: string) => void;
  setPromoteFlowTitle: (value: string) => void;
  handleToast: (toast: Toast) => void;
}) => {
  const {
    components,
    appLoading,
    continueDraft,
    setComponents,
    contactBox,
    postBox,
    prevData,
    closeButtonText,
    closeButtonTitle,
    forceRenderContactUs,
    forceRenderPostCartInfo,
    setHandleToastTrigger,
    toastHandler,
  } = useComponentsStore((state) => state);

  const { language, isDeviceMobile, setToken } = useAppStore();
  if(loggingConfig && loggingConfig.loggingEnv){
    loggingConfig.loggingEnv.token = token;
  }
  useLogging(language, loggingConfig);

  useEffect(() => {
    sessionStorage.setItem("cameFromVas", "true");
    setHandleToastTrigger(handleToast);
    const urlParams = new URLSearchParams(window.location.search);
    const cartId = urlParams.get("cartId");
    const modelId = +urlParams.get("post_id");
    const cta = urlParams.get("cta");
    const pos = urlParams.get("pos");
    const actionSource = urlParams.get("actionSource");
    const redirect = +urlParams.get("redirect") || 0;

    if (!modelId || !token) {
      return;
    }

    let payload = {
      Payment: {
        modelId: modelId,
        posSource: pos ?? "",
        cta: cta ?? "",
        absoluteUrl: window?.location?.href ?? "",
        actionSource: actionSource || "promote",
      },
    };
    setToken(token);
    if (cartId) {
      continueDraft({ cartId, redirect, ...payload });
      logOrderProductsView();
    } else {
      InitDraft(payload, token)
        .then((res) => {
          const data: ResType = res.data;
          setComponents(data);
          logOrderProductsView();
        })
        .catch((err) => {
          console.log(err);
          toastHandler("error", 2000);
        });
    }
    if (redirect) urlParams.delete("redirect");

    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
  }, [setComponents, setToken, token]);

  useEffect(() => {
    if (trigger && prevData) {
      continueDraft(prevData).then(() => {
        setTrigger(false);
      });
    }
  }, [trigger, setTrigger]);

  useEffect(() => {
    if (prevData) {
      handleEnableBackButton(true);
    } else {
      handleEnableBackButton(false);
    }
  }, [handleEnableBackButton, prevData]);

  useEffect(() => {
    if (closeButtonText) setPromoteFlowCloseText(closeButtonText);
    if (closeButtonTitle) setPromoteFlowTitle(closeButtonTitle);
  }, [
    setPromoteFlowCloseText,
    closeButtonText,
    closeButtonTitle,
    setPromoteFlowTitle,
  ]);

  return (
    <div
      className="vas-d-flex vas-flex-column vas-w-100 vas-align-items-center"
      // onClick={()=>setOpen(true, "")}
      //TODO: Remove vas-container
    >
      <div
        className={`vas-d-flex ${
          isDeviceMobile ? "vas-flex-column" : 'vas-gap-3'
        } vas-justify-content-center vas-align-items-start vas-w-100`}
        dir={language === "ar" ? "rtl" : "ltr"}
        style={
          {
            // marginTop: "50px",
            // maxWidth: "1170px",
          }
        }
      >
        {!appLoading && !trigger && (
          <div
            className={`vas-w-100 vas-d-flex vas-flex-column ${
              isDeviceMobile ? "vas-pt-3 vas-bg-white" : "vas-px-0 vas-gap-4"
            }`}
            style={styleHelper({ maxWidth: "" })}
          >
            {components &&
              components.map((component, idx) => (
                <Mapper widget={component} key={idx} />
              ))}
          </div>
        )}
        {(!appLoading && !trigger) && (<div className={`vas-d-flex vas-gap-4 vas-flex-column ${styles.sticky_column} vas-w-50`}>
          {(!isDeviceMobile || forceRenderPostCartInfo) &&
              !appLoading &&
              !trigger &&
              postBox && <PostCartInfo data={postBox} />}
          {(!isDeviceMobile || forceRenderContactUs) &&
              !appLoading &&
              !trigger &&
              contactBox && <ContactUs data={contactBox} />}
        </div>)}
        {(appLoading || trigger) && (
          <SkeletonLoader isDeviceMobile={isDeviceMobile} />
        )}
        <LearnMoreModal />
        {/* <ConfirmationModal /> */}
      </div>
    </div>
  );
};

export default VasServices;
